import React from "react";
import { Element } from "react-scroll";

const Home = () => {
  return (
    <Element
      name="home"
      class="pr-[20px] pl-[20px] sm:pr-[50px] sm:pl-[50px] inline sm:flex flex-row items-center justify-between self-stretch shrink-0 relative"
    >
      <div class="flex flex-col lg:gap-20 items-start justify-center flex-1 relative">
        <div class="self-stretch shrink-0 md:h-32 xl:h-32 relative">
          <div class="text-[#006400] text-left font-['JejuGothic-Regular',_sans-serif] text-4xl sm:text-5xl md:text-5xl lg:text-7xl xl:text-8xl font-normal">
            Iordan
            <br />
            Ionut Marius
          </div>
        </div>
        <div class="flex flex-col gap-2.5 items-start justify-start self-stretch shrink-0 relative">
          <div class="flex flex-row gap-2.5 items-center justify-end self-stretch shrink-0 relative">
            <div
              class="text-[#919191] text-left font-['Inter-Regular',_sans-serif] font-normal relative flex-1
              sm:text-lg md:text-xl lg:text-2xl xl:text-3xl"
            >
              Hello, my name is Ionut. Nice to meet you! I would like to welcome
              you to my personal portfolio.
            </div>
          </div>
        </div>
      </div>
      <div
        className={
          "flex flex-row items-center justify-between shrink-0 relative "
        }
      >
        <img
          className={
            "flex-1 h-3/6 sm:h-[400px] md:h-[500px] lg:h-[600px] xl:h-[700px] rounded-[327px] relative opacity-60"
          }
          style={{ objectFit: "cover" }}
          src={`${process.env.PUBLIC_URL}/Image.png`}
          alt="im"
        />
      </div>
      <svg
        class="shrink-0 absolute overflow-visible md:w-[149.75px] sm:w-[100px] sm:h-[100px] md:h-[149.12px] w-[70px] h-[70px]
        sm:left-[calc(50%_-_1.78px)] md:left-[calc(80%_-_303.78px)] md:top-[calc(10%_-_-16.5px)] sm:top-[calc(1%_-_-16.5px)] sm:left-[calc(20%_-_-16.5px)] 
        left-[calc(30%_-_10.78px)] top-[calc(70%_-_-10.5px)]"
        style={{ transform: "translate(-81.7px, 0px)" }}
        width="208"
        height="208"
        viewBox="0 0 208 208"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_4_24)">
          <path
            d="M85.063 63.89L48.7104 68.2284L59.533 103.203"
            stroke="white"
            stroke-opacity="0.7"
            stroke-width="12"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M147.963 104.738L158.786 139.712L122.433 144.051"
            stroke="white"
            stroke-opacity="0.7"
            stroke-width="12"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M147.556 70.9384L59.9402 137.002"
            stroke="white"
            stroke-opacity="0.7"
            stroke-width="12"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_4_24">
            <rect
              width="150"
              height="150"
              fill="white"
              transform="translate(81.6958 0.222168) rotate(33)"
            />
          </clipPath>
        </defs>
      </svg>
      <svg
        class="shrink-0 md:w-[149.75px] sm:w-[100px] sm:h-[100px] md:h-[149.12px] w-[70px] h-[70px]
        absolute sm:left-[calc(50%_-_1.78px)] md:left-[calc(90%_-_303.78px)] md:top-[calc(30%_-_-166.5px)] sm:top-[calc(50%_-_-16.5px)] sm:left-[calc(80%_-_-16.5px)]
        overflow-visible left-[calc(70%_-_10.78px)] top-[calc(50%_-_-10.5px)]"
        style={{ transform: "translate(-81.22px, 0px)" }}
        width="207"
        height="207"
        viewBox="0 0 207 207"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_4_28)">
          <path
            d="M84.5102 63.0968L48.1576 67.4351L58.9803 102.409"
            stroke="white"
            stroke-opacity="0.7"
            stroke-width="12"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M147.213 70.2813L59.597 136.345"
            stroke="white"
            stroke-opacity="0.7"
            stroke-width="12"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M147.83 104.217L158.652 139.191L122.3 143.53"
            stroke="white"
            stroke-opacity="0.7"
            stroke-width="12"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_4_28">
            <rect
              width="149.75"
              height="149.125"
              fill="white"
              transform="translate(81.2192) rotate(33)"
            />
          </clipPath>
        </defs>
      </svg>
      <svg
        class="shrink-0 absolute overflow-visible md:w-[149.75px] sm:w-[100px] sm:h-[100px] md:h-[149.12px] w-[70px] 
        h-[70px] sm:left-[calc(50%_-_1.78px)] md:left-[calc(55%_-_303.78px)] md:top-[calc(40%_-_-166.5px)] sm:top-[calc(70%_-_-16.5px)] sm:left-[calc(40%_-_23.78px)] 
        left-[calc(30%_-_10.78px)] top-[calc(30%_-_-10.5px)]"
        style={{ transform: "translate(-81.7px, 0px)" }}
        width="208"
        height="208"
        viewBox="0 0 208 208"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_4_32)">
          <path
            d="M85.063 63.6678L48.7104 68.0062L59.533 102.981"
            stroke="white"
            stroke-opacity="0.7"
            stroke-width="12"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M147.963 104.516L158.786 139.49L122.433 143.829"
            stroke="white"
            stroke-opacity="0.7"
            stroke-width="12"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M147.556 70.7162L59.9402 136.78"
            stroke="white"
            stroke-opacity="0.7"
            stroke-width="12"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_4_32">
            <rect
              width="150"
              height="150"
              fill="white"
              transform="translate(81.6958) rotate(33)"
            />
          </clipPath>
        </defs>
      </svg>
    </Element>
  );
};

export default Home;
